import { IAttributeLayout, BlendMode, AttributeSize } from "./webgl_types.js";

export interface IBatchConfig<TLayout extends Record<string, AttributeSize> = any>
{
  max_instances         : number;
  vertices_per_instance : number;
  primitive_type        : GLenum;
  layout                ?: TLayout;
  attribute_layout      ?: IAttributeLayout[];
  blend_mode            ?: BlendMode;
  enable_z_sort         ?: boolean;
}

export enum InstanceState 
{
  Alive    = 0,
  Stopping = 1,
  Dead     = 2,
}

export enum CurveType
{
  NotMove,
  Linear,
  Spiral,
  Zigzag,
  Circular,
  Bounce,
  Ellipse,
  Sine,
  Bezier,
}